'use strict';
import React from 'react';
import * as T from 'prop-types';
import {List} from '../../../components/lists/List';
import {getId} from '../../../core-utilities/domain/ReduxUtils';
import {ViewMode} from '../../../core-utilities/enums/ViewMode';
import {I18nComponent} from '../../../core-utilities/react-i18n/I18nComponent';
import {SvgIcons} from '../../../core-components/svg-menu-icons/icons';
import {CreateOrgCard} from '../CreateOrgCard';
import {OrgCard} from '../OrgCard';


export function BaseOrgListView(props) {
  return (
    <List
      className="OrgList"
      useScroll={props.useScroll}
      flipped={false}
      autoScroll={false}
      mode={props.mode}
      onLoadMore={props.onLoadMore}
      transitionGroupClass={'OrgList__container'}
      showNoData={false}
    >
      {props.mode === ViewMode.SUCCESS || props.mode === ViewMode.NO_DATA ? (
        <CreateOrgCard
          className="OrgList__card OrgList__card_createCard"
          placeholderLabelClass="OrgList__card__createButton"
          placeholderLabel={props.placeholderLabel}
          svgIcon={SvgIcons.Plus}
        />
      ) : null}
      {props.list ? props.list.map(model => (
        <OrgCard
          key={getId(model)}
          className="OrgList__card"
          model={model}
          onClick={props.onClickItem}
          onShowOptions={props.onItemShowOptions}
        />
      )) : null}
    </List>
  );
}

BaseOrgListView.propTypes = {
  list: T.array.isRequired,
  onClickItem: T.func,
  onItemShowOptions: T.func,
  placeholderLabel: T.string,
};

export const OrgListView = I18nComponent(BaseOrgListView, [
  {code: 'organizations.create.new.label', prop: 'placeholderLabel'},
]);



// WEBPACK FOOTER //
// ./src/js/organizations/components/OrgList/OrgListView.js